(ns frontend.view.modals.error-message.view
  (:require
   [ui.components.modal.view :as modal]))

(defonce modal-key :error-message-modal)

(defn view
  [{:keys [shown? close-modal! props topmost?]}]
  (let [{:keys [ok-button-text title body-content on-ok!]} props]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     title
     [:p
      {:class "text-center"}
      body-content]
     [modal/right-single-button
      nil
      false
      (fn [_]
        (close-modal!)
        (when on-ok!
          (on-ok!)))
      ok-button-text
      nil]]))
